import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import intlTelInput from 'intl-tel-input';

import { selectSettingHomescreen } from 'src/app/stores/settings';

import { Country } from '../../interfaces/Country';
import { IntlTelInput } from '../../interfaces/intlTelInput';
import { PhoneNumberService } from '../../services/phone-number/phone-number.service';

@Component({
  selector: 'frodo-country-selector',
  templateUrl: './country-selector.component.html',
  styleUrls: ['./country-selector.component.scss'],
})
export class CountrySelectorComponent implements AfterViewInit, OnDestroy {
  @ViewChild('countrySelector') phoneNumberField: ElementRef;

  @Output() phoneNumberEmitter = new EventEmitter<{
    length: number;
    dialCode: string;
  }>();

  countries: Country[] = [];
  phoneNumber: IntlTelInput;
  selectedCountry: string;
  subscription: Subscription = new Subscription();

  constructor(
    private store: Store,
    private changeDetectorRef: ChangeDetectorRef,
    private countryService: PhoneNumberService
  ) {}

  ngAfterViewInit() {
    this.initializePhoneNumberInput();
  }

  initializePhoneNumberInput(): void {
    if (this.phoneNumberField) {
      this.subscription.add(
        this.store.select(selectSettingHomescreen).subscribe((homescreen) => {
          if (this.phoneNumber) {
            /* istanbul ignore next */
            this.phoneNumber.destroy();
          }
          const initialCountry = homescreen.country.toLowerCase();
          this.phoneNumber = intlTelInput(this.phoneNumberField.nativeElement, {
            initialCountry,
            formatOnDisplay: false,
          });
          this.populateCountries();
          this.selectedCountry = this.phoneNumber.selectedCountryData.iso2;
          this.changeDetectorRef.detectChanges();
        })
      );
    }
  }

  populateCountries(): void {
    this.countries = this.phoneNumber.countries.map((country: Country) => ({
      ...country,
      iso2: country.iso2.toLowerCase(),
      displayName: `${this.formatDialCode(country.dialCode)} ${country.name}`,
    }));
  }

  public formatDialCode(dialCode: string): string {
    return `(+${dialCode})`;
  }

  onCountryChange(countryIsoCode: string): void {
    this.selectedCountry = countryIsoCode;
    this.phoneNumber.setCountry(countryIsoCode);
    this.emitPhoneNumber(countryIsoCode);
  }

  emitPhoneNumber(countryCode: string): void {
    const examplePhoneNumber = this.countryService.getExamplePhoneNumber(countryCode);

    this.phoneNumberEmitter.emit({
      dialCode: examplePhoneNumber.countryCallingCode,
      length: examplePhoneNumber.nationalNumber.length,
    });
  }

  trackByIso2(country: Country): string {
    return country.iso2;
  }

  get selectedCountryData(): Country | undefined {
    return this.countries.find((country) => country.iso2 === this.selectedCountry);
  }

  ngOnDestroy(): void {
    if (this.phoneNumber) {
      this.phoneNumber.destroy();
      this.phoneNumber = undefined;
    }
    this.subscription.unsubscribe();
    this.phoneNumberField = undefined;
  }
}
